import React from 'react';
import { Icon } from './Icon.js';
export const IconBoltSpeed = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 10H22V11L15 22H14V14H8V13L15 2H16V10Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" }),
        React.createElement("path", { d: "M1 12H4", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 6H6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 18H6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBoltSpeed.js.map